import React from "react";
import { useFormRecord } from "../../../../common/controls/forms/FormRecordContext";
import { CredentialField } from "./credentialField";

/**
 * Componente custom para TadManagerConfig.arcaPassword ("Clave Fiscal ARCA").
 *
 * Sólo se muestra cuando el Proveedor de Identidad elegido es "arca".
 * Ocultarse no borra el valor: el componente simplemente no se monta, por lo que
 * el onChange nunca se dispara y lo guardado sigue guardado.
 *
 * El campo y su indicador de "credencial cargada" viven en CredentialField, común a
 * las cuatro credenciales; acá queda sólo la visibilidad. La guarda de proveedor va
 * ANTES de montarlo para que sólo la credencial visible consulte su estado al server.
 *
 * Llená/editá este archivo en `develop`. El generador lo emite como stub estable en
 * `base` (merge-safe). Recibe los mismos props que un control estándar del form.
 */
export interface TadManagerConfigArcaPasswordCustomFieldProps {
  value: any;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  description?: string;
}

export const TadManagerConfigArcaPasswordCustomField: React.FC<
  TadManagerConfigArcaPasswordCustomFieldProps
> = (props) => {
  const { values } = useFormRecord();
  const provider = values?.authProvider || "renaper";
  if (provider !== "arca") return null;

  return <CredentialField field="arcaPassword" {...props} />;
};
